package net.sergeych.kilogin

import net.sergeych.kiloparsec.LocalInterface


class KLInternalException(reason: String?="superlogin internal exception (a bug)", cause: Throwable?=null):
        Exception(reason, cause)



fun registerSuperloginExceptions(er: LocalInterface<*>) {
    er.registerError { KLInternalException(it) }
}
